var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.verificarVtnFinalizada() && _vm.$route.name === "gerenciamento-daes"
        ? _c(
            "div",
            { staticClass: "card-info" },
            [
              _c("el-row", [
                _c("div", { staticClass: "d-flex tb" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("p", { staticClass: "verde-text text-aviso" }, [
                      _vm._v(_vm._s(_vm.vtn.titulo))
                    ]),
                    _c("p", { staticClass: "verde-text text-between" }, [
                      _vm._v(_vm._s(_vm.vtn.mensagem))
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "botao" },
                    [
                      _vm.vtn.vencido
                        ? _c(
                            "el-button",
                            {
                              staticClass: "green textButtonBreak",
                              attrs: { tipo: "success" },
                              on: {
                                click: function($event) {
                                  return _vm.reemite()
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "center" }, [
                                _c("i", { staticClass: "fal fa-credit-card" }),
                                _vm._v("  Reemitir DAE")
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm.hasVtn
                        ? _c(
                            "el-button",
                            {
                              staticClass: "green textButtonBreak",
                              attrs: { tipo: "success" },
                              on: {
                                click: function($event) {
                                  return _vm.goLink(false)
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "center" }, [
                                _c("i", { staticClass: "fal fa-credit-card" }),
                                _vm._v("  " + _vm._s(_vm.vtn.mensagemBotao))
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.resumoExcedentes, function(vtnEx, index) {
        return _vm.verificarVtnFinalizada() &&
          _vm.$route.name === "gerenciamento-daes" &&
          _vm.isPara &&
          _vm.vtn.temExcedente
          ? _c(
              "div",
              { staticClass: "card-info" },
              [
                _c("el-row", [
                  _c("div", { staticClass: "d-flex tb" }, [
                    _c("div", { staticClass: "column" }, [
                      _c("p", { staticClass: "verde-text text-aviso" }, [
                        _vm._v(_vm._s(vtnEx.tituloExcedente))
                      ]),
                      _c("p", { staticClass: "verde-text text-between" }, [
                        _vm._v(_vm._s(vtnEx.mensagemExcedente))
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "botao" },
                      [
                        vtnEx.vencido
                          ? _c(
                              "el-button",
                              {
                                staticClass: "green textButtonBreak",
                                attrs: { tipo: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.reemiteExcedente()
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "center" }, [
                                  _c("i", {
                                    staticClass: "fal fa-credit-card"
                                  }),
                                  _vm._v("  Reemitir DAE")
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.hasVtn
                          ? _c(
                              "el-button",
                              {
                                staticClass: "green textButtonBreak",
                                attrs: { tipo: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.goLink(true, index)
                                  }
                                }
                              },
                              [
                                _c("span", { staticClass: "center" }, [
                                  _c("i", {
                                    staticClass: "fal fa-credit-card"
                                  }),
                                  _vm._v(
                                    "  " + _vm._s(vtnEx.mensagemBotaoExcedente)
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            )
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4177551c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4177551c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/centralMensagens/AppAvisoVtn.vue
// module id = null
// module chunks = 